<template>
  <v-container fluid class="pt-0">
    <v-row>
      <v-col cols="auto">
        <v-chip-group
          v-model="textareaCols"
          mandatory
          active-class="primary--text"
        >
          <span
            class="subheading mr-2"
            style="line-height: 32px !important; align-self: center"
            >{{ $t("layout") }}:</span
          >
          <v-chip :value="6" filter> 1:1 </v-chip>
          <v-chip :value="3" filter> 1:2 </v-chip>
          <v-chip :value="9" filter> 2:1 </v-chip>
        </v-chip-group>
      </v-col>
      <v-col cols="auto">
        <v-switch
          v-model="switch1"
          @change="autoDetect(textarea)"
          color="primary"
          class="mt-2"
          :label="
            switch1
              ? $t('excludeNameFromDescription')
              : $t('doNotExcludeNameFromDescription')
          "
          hide-details
        ></v-switch>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="textareaCols">
        <v-textarea
          v-model="textarea"
          @input="autoDetect(textarea)"
          :label="$t('dailyMenu')"
          :placeholder="$t('autoDetectPlaceholder')"
          :hint="$t('autoDetectHint')"
          rows="10"
          clearable
          auto-grow
          filled
          rounded
          persistent-hint
        ></v-textarea>
      </v-col>
      <v-col :cols="12 - textareaCols">
        <v-data-table
          :headers="headers"
          :header-props="{ sortByText: $t('sortBy') }"
          :items="detectedItems"
          item-key="$id"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.date="{ item }">
            <v-chip small :color="stringToHslColor(item.date)">{{
              item.date
            }}</v-chip>
          </template>
          <template v-slot:item.id="props">
            <v-edit-dialog :return-value.sync="props.item.id">
              {{ props.item.id }}
              <template v-slot:input>
                <v-text-field
                  v-model="props.item.id"
                  type="number"
                  :label="$t('id')"
                  single-line
                  rounded
                  filled
                  :hint="$t('toConfirmPressEnter')"
                  persistent-hint
                  class="mt-2"
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.name="props">
            <v-edit-dialog :return-value.sync="props.item.name">
              {{ props.item.name }}
              <template v-slot:input>
                <v-text-field
                  v-model="props.item.name"
                  :label="$t('name')"
                  single-line
                  rounded
                  filled
                  :hint="$t('toConfirmPressEnter')"
                  persistent-hint
                  class="mt-2"
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.description="props">
            <v-edit-dialog :return-value.sync="props.item.description">
              {{ props.item.description }}
              <template v-slot:input>
                <v-text-field
                  v-model="props.item.description"
                  :label="$t('description')"
                  single-line
                  rounded
                  filled
                  :hint="$t('toConfirmPressEnter')"
                  persistent-hint
                  class="mt-2"
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.allergens="props">
            <v-edit-dialog
              :return-value.sync="props.item.allergens"
              large
              :save-text="$t('save')"
              :cancel-text="$t('close')"
            >
              {{ props.item.allergens.join(", ") }}
              <template v-slot:input>
                <v-chip-group
                  v-model="props.item.allergens"
                  multiple
                  active-class="primary--text"
                  class="mt-2"
                >
                  <v-chip
                    v-for="allergen in 14"
                    :key="allergen + 1"
                    :value="allergen.toString()"
                    small
                  >
                    {{ allergen }}
                  </v-chip>
                </v-chip-group>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.amount="props">
            <v-edit-dialog :return-value.sync="props.item.amount">
              {{ props.item.amount }}
              <template v-slot:input>
                <v-text-field
                  v-model="props.item.amount"
                  :label="$t('amount')"
                  single-line
                  rounded
                  filled
                  :hint="$t('toConfirmPressEnter')"
                  persistent-hint
                  class="mt-2"
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.price="props">
            <v-edit-dialog :return-value.sync="props.item.price">
              {{ props.item.price }}
              <template v-slot:input>
                <v-text-field
                  v-model="props.item.price"
                  type="number"
                  :label="$t('price')"
                  single-line
                  rounded
                  filled
                  :hint="$t('toConfirmPressEnter')"
                  persistent-hint
                  class="mt-2"
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import restaurantService from "../services/restaurant.service";

export default {
  data() {
    return {
      textareaCols: 6,
      switch1: false,
      textarea: "",
      headers: [
        { text: this.$t("date"), value: "date" },
        { text: this.$t("id"), value: "id" },
        { text: this.$t("name"), value: "name" },
        {
          text: this.$t("description"),
          value: "description",
          sortable: false,
        },
        { text: this.$t("allergens"), value: "allergens", sortable: false },
        { text: this.$t("amount"), value: "amount", sortable: false },
        { text: this.$t("price"), value: "price" },
        { text: this.$t("actions"), value: "actions", sortable: false },
      ],
      detectedItems: [],
    };
  },
  methods: {
    autoDetect(text) {
      const dateRegex =
        /((0[1-9]|[12]\d|3[01])[-/.](0[1-9]|1[0-2])[-/.][12]\d{3})/g;
      const amountRegex = /([0-9]* *([\.\,]{0,1} *[0-9]+)) *[a-z]+/g;
      const allergensRegex =
        /(\bA{0,1} {0,1}([1-9]|1[0-4])\b)([,; ]{1} {0,1}(\bA{0,1} {0,1}([1-9]|1[0-4])\b))+[ \n]/g;
      const allergensRegex2 = /(\b([1-9]|1[0-4])\b)/g;
      const priceRegex = /([0-9]*([\.\,]{0,1}[0-9]+)) *([€\$E]|K(?:c|č)|Czk)+/g;
      const priceRegex2 = /^[0-9]*[.,]{0,1}[0-9]*/g;
      // const descriptionRegex = /\p{Lu}{1}(\p{Ll}+[ ,.:;-]*)+/gu;
      // const nameRegex = /\p{Lu}{1}(\p{Ll}+[ .:-]*)+/gu;
      const descriptionRegex = /\p{Lu}{1}(\p{L}+[ ,.:;-–]*)+/gu;
      const nameRegex = /\p{Lu}{1}(\p{L}+[ .:-–]*)+/gu;

      const splited = text.split("\n\n");

      let dailyMenu = [];

      splited.forEach((e) => {
        try {
          const originalDate = e.match(dateRegex)[0];
          let date = e.match(dateRegex)[0];
          date = date.split(/[-/.]/).reverse().join("-");

          const lines = e.split("\n");

          lines.forEach((elem) => {
            const line = (elem += " ");
            const status = true;
            const id = "";

            let name = line.match(nameRegex);
            if (name !== null) name = name.join("").trim();

            let description = line.match(descriptionRegex);
            if (description !== null) description = description.join("").trim();
            if (this.switch1 && !line.includes(originalDate))
              description = description
                .replace(name, "")
                .replace(/^[,;]/g, "")
                .trim();

            let amount = line.match(amountRegex);
            if (amount !== null) amount = amount.join(" ").trim();
            else amount = "";

            let allergens = line.match(allergensRegex);
            if (allergens !== null)
              allergens = allergens[0].replace(/A/g, "").match(allergensRegex2);
            if (allergens === null) allergens = [];

            let price = line.match(priceRegex);
            if (price !== null) price = price[0].trim().match(priceRegex2);
            if (price !== null) price = price[0].replace(/,/g, ".");
            if (price === null) price = 0;

            if (!line.includes(originalDate) && name.length > 0)
              dailyMenu.push({
                date,
                status,
                id,
                name,
                description,
                amount,
                allergens,
                price,
              });
          });
        } catch {}
      });
      return (this.detectedItems = dailyMenu);
    },
    deleteItem(item) {
      const index = this.detectedItems.indexOf(item);
      this.detectedItems.splice(index, 1);
    },
    stringToHslColor: function (str, s = 100, l = 75) {
      let revStr = str.split("").reverse().join("");
      let hash = 0;
      for (let i = 0; i < revStr.length; i++) {
        hash = revStr.charCodeAt(i) + ((hash << 5) - hash);
      }
      const h = hash % 360;
      return "hsl(" + h + ", " + s + "%, " + l + "%)";
    },
    async addDailyMenuDishes() {
      if (
        window.confirm(
          this.$t("areYouSureYouWantToImportDishes", {
            amount: this.detectedItems.length,
          })
        )
      ) {
        this.$emit("loading");
        const resp = await restaurantService.addDailyMenuDishes(
          localStorage.getItem("restaurantId"),
          this.detectedItems
        );
        this.$emit("updateItems", resp);
        this.textarea = "";
        this.detectedItems = [];
      }
    },
  },
};
</script>

<style scoped>
.v-small-dialog__actions .v-btn:nth-child(2) {
  color: #13e46d !important;
}

.v-small-dialog__actions .v-btn {
  border-radius: 28px;
}
</style>>
</style>